import SinginForm from "../../components/SinginForm";
const Singin = () => {
    return (
        <main className="login mx-auto row text-white">
            <section className="col  d-flex justify-content-end">
                <h1 id="bienvenida" className="m-0">"Reserva <span className="bienvenida-highlight">fácil</span> e infórmate del estado y disponibilidad de cada equipo de nuestro: Centro de Operaciones y Logística <span className="bienvenida-highlight-green">(COL)</span> de Ecoturismo".</h1>
            </section>
            <section className="col  d-flex justify-content-start">
                <SinginForm />
            </section>
        </main>
    )
}
export default Singin;